import moment from 'moment-timezone';

export function parseDate(datestr: string, format: string): Date {
  return moment(datestr, format).toDate();
}

export function format(date: Date, format: string): string {
  return format ? moment(date).format(format) : moment(date).format();
}

export function isValid(date: Date): boolean {
  return moment(date).isValid();
}
export function rezoneToRome(date: Date, hourOffset?: number, minuteOffset?: number): Date {

  const momobj = moment(date).clone();

  if (hourOffset) {
    momobj.hours(hourOffset);
  }
  if (minuteOffset) {
    momobj.minutes(minuteOffset);
  }
  const rezonedobj = moment.tz(momobj.format('YYYY-MM-DDTHH:mm:ss.SSS'), 'Europe/Rome');
  return rezonedobj.toDate();
}

export function romeToLocal(date: Date) {
  // return utcToZonedTime(date, 'Europe/Rome');
  const momobj = moment(date).clone();
  const rezonedobj = moment.tz(momobj.tz('Europe/Rome').format('YYYY-MM-DDTHH:mm:ss.SSS'), moment.tz.guess());
  return rezonedobj.toDate();
}